import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import  ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function NYTimesRightToBeauty({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  const m = ProjectModel.NYTimesRightToBeauty;

  return (
<div className="wrapper">
	<div className="inner-wrapper">
		<Helmet>
		    <meta charSet="utf-8" />
		    <title>Maria Chimishkyan — {m.title}</title>
		</Helmet>

	    <Container fluid className="page-pad">
	    	<Row>
	    		<Col sm={3}>
	    			<div className="description-sticky">
	    			  <ProjectDescription projectModel={ProjectModel.NYTimesRightToBeauty}/>
	    			</div>
	    		</Col>
	    		<Col sm={6}>
	    			<img src= "img/project-page/nytimes-right-to-beauty/nytimes_righttobeauty_MariaChimishkyan.jpg" alt="NY Times — Right to Beauty - Maria Chimishkyan 1" style={{ width: '100%' }}/>
	    		</Col>
	    	</Row>
	    </Container>
	</div>
	<ProjectIndex/>
</div>

  )
}

export default connect()(NYTimesRightToBeauty);
